import { eventBus } from '@sm/max-common';

export const subPageBus = eventBus.create();
